module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-12.411db349.jpg";